import React, { useState } from 'react';

import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/pics';
const attr = [
  'body', 'bodylight', 'tail', 'face', 'nose', 'eyes', 'facemask', 'necklace',
  'hair', 'back_l', 'back_r', 'front_l', 'front_r', 'egg',
];

const ListPics = () => {
  const filter = {};
  const [type, setType] = useState('');

  // hide 'final & egg_final_?' img
  if (type) {
    filter.$and = [
      { type: { $in: attr } },
      { type },
    ];
  } else {
    filter.$and = [
      { type: { $in: attr } },
    ];
  }

  return (
    <ListResource
    {...{
      // searchable: true,
      api,
      sort: { type: 1, picId: -1 },
      filter,
      actions: {
        fileImport: { url: '/api/site/pics/files' },
      },
      cols: [
        { key: 'type', sortable: true, children: 'Type' },
        { key: 'picId', sortable: true, children: 'Pic ID' },
        { key: 'description' },
        { key: 'src' },
        { key: 'bloodline', getter: (v) => v.join(', ') },
        {
          key: 'probi',
          sortable: true,
          children: 'Probability',
          getter: (v) => `${(v * 100).toFixed(1).toString()}%`,
        },
      ],
      ctrls: [
        <select
          className="custom-select"
          key={0}
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="">Select Attribute</option>
          {attr.map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>,
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
  );
};

export default ListPics;
